import type {
	InsuredPersonDTO,
	InsuredPersonRiskDTO,
} from "web_myplann/Infrastructure/Api/Api";

export type InsuredPersonRiskWithValue = {
	risk: InsuredPersonRiskDTO;
	value: number;
};

export type InsuredPersonWithRisks = {
	person: InsuredPersonDTO;
	risks: InsuredPersonRiskWithValue[];
};

export const insuredPersonsWithRisks = (
	insuredPersons: InsuredPersonDTO[] | null | undefined,
): InsuredPersonWithRisks[] =>
	(insuredPersons ?? []).map((person) => ({
		person,
		risks: (person.risks ?? []).reduce<InsuredPersonRiskWithValue[]>(
			(accumulator, risk) => {
				if (typeof risk.value === "number") {
					accumulator.push({ risk, value: risk.value });
				}

				return accumulator;
			},
			[],
		),
	}));
